import * as React from 'react';

import { StyleButton } from './StyleButton';

export const INLINE_STYLES = [
  { style: 'BOLD', icon: 'editor-style-bold' },
  { style: 'ITALIC', icon: 'editor-style-italic' },
  { style: 'UNDERLINE', icon: 'editor-style-underline' },
  { style: 'STRIKETHROUGH', icon: 'editor-style-strikethrough' }
];

type Props = {
  editorState: any,
  onToggle: (a: string) => void
};

class InlineStyleControls extends React.PureComponent<Props> {
  render(): React.ReactNode {
    const { editorState, onToggle } = this.props;
    const currentStyle = editorState.getCurrentInlineStyle();

    return (
      <section className="rich-text-editor__buttons">
        {
          INLINE_STYLES.map(type =>
            <StyleButton
              key={type.style}
              active={currentStyle.has(type.style)}
              type={type}
              onToggle={onToggle}
            />
          )
        }
      </section>
    );
  }
}

export default InlineStyleControls;
